import { useStatsigClient } from '@statsig/react-bindings'
import { PropsWithChildren, useCallback, useMemo } from 'react'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'

import { statsigExperimentManager } from './statsig-experiment.manager'
import { StatsigInitContext } from './statsig.context'

export function StatsigUserAwareProvider({ children }: PropsWithChildren) {
  const client = useStatsigClient()
  const getExperimentBucket = useCallback(
    (experimentName: STATSIG_EXPERIMENTS | null) => {
      if (!experimentName) return null
      const fallback = STATSIG_EXPERIMENTS_CONFIG[experimentName].defaultBucket
      try {
        const experiment = client.getExperiment(experimentName)
        if (experiment.groupName) {
          // experiment is either active or shipped
          const isActive = experiment.__evaluation?.is_experiment_active ?? false
          statsigExperimentManager.setExposedBuckets(experimentName, experiment.groupName, isActive)
        } else {
          // experiment is not started or abandoned
          statsigExperimentManager.removeExposedBuckets(experimentName)
        }
        return experiment.groupName ?? fallback
      } catch {
        return fallback
      }
    },
    [client],
  )
  const value = useMemo(
    () => ({ init: client.client.loadingStatus === 'Ready', getExperimentBucket }),
    [client.client.loadingStatus, getExperimentBucket],
  )
  return <StatsigInitContext.Provider value={value}>{children}</StatsigInitContext.Provider>
}
